import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import { DOSTUPNOST_JEDNOTKA_URL, DOSTUPNOST_HZS_SMENA_AKTUALNI_URL, DOSTUPNOST_HISTORIE_URL } from "../url";
import type { Dostupnost } from "../generated/models/Dostupnost";

const getDostupnostJednotky = () =>
    handleRequest<Dostupnost[]>(() => axiosInstance.get(DOSTUPNOST_JEDNOTKA_URL));

const getDostupnostHistorie = (uzivatelId: number) =>
    handleRequest<Dostupnost[]>(() => axiosInstance.get(DOSTUPNOST_HISTORIE_URL(uzivatelId)));

const getHzsSmenaAktualni = () =>
    handleRequest<{ currentShift: string }>(() => axiosInstance.get(DOSTUPNOST_HZS_SMENA_AKTUALNI_URL));

const DostupnostService = { getDostupnostJednotky, getDostupnostHistorie, getHzsSmenaAktualni };
export default DostupnostService;
